var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("form", { staticClass: "h-100", class: _vm.theme }, [
    _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "form-group col-md-4" }, [
        _c("label", { attrs: { for: "inputTimeLimit" } }, [
          _vm._v(_vm._s(_vm.T.settingsTimeLimit)),
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.timeLimit,
              expression: "timeLimit",
              modifiers: { number: true },
            },
          ],
          staticClass: "form-control",
          attrs: { max: "5.0", min: "0.1", step: "0.1", type: "number" },
          domProps: { value: _vm.timeLimit },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.timeLimit = _vm._n($event.target.value)
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
      ]),
      _c("div", { staticClass: "form-group col-md-4" }, [
        _c("label", { attrs: { for: "inputOverallWallTimeLimit" } }, [
          _vm._v(_vm._s(_vm.T.settingsOverallWallTimeLimit)),
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.overallWallTimeLimit,
              expression: "overallWallTimeLimit",
              modifiers: { number: true },
            },
          ],
          staticClass: "form-control",
          attrs: { max: "5.0", min: "0.1", step: "0.1", type: "number" },
          domProps: { value: _vm.overallWallTimeLimit },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.overallWallTimeLimit = _vm._n($event.target.value)
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
      ]),
      _c("div", { staticClass: "form-group col-md-4" }, [
        _c("label", { attrs: { for: "inputExtraWallTime" } }, [
          _vm._v(_vm._s(_vm.T.settingsExtraWallTime)),
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.extraWallTime,
              expression: "extraWallTime",
              modifiers: { number: true },
            },
          ],
          staticClass: "form-control",
          attrs: { max: "5.0", min: "0.0", step: "0.1", type: "number" },
          domProps: { value: _vm.extraWallTime },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.extraWallTime = _vm._n($event.target.value)
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
      ]),
    ]),
    _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", { attrs: { for: "inputMemoryLimit" } }, [
          _vm._v(_vm._s(_vm.T.settingsMemoryLimit)),
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.memoryLimit,
              expression: "memoryLimit",
              modifiers: { number: true },
            },
          ],
          staticClass: "form-control",
          attrs: {
            max: "1073741824",
            min: "33554432",
            step: "1048576",
            type: "number",
          },
          domProps: { value: _vm.memoryLimit },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.memoryLimit = _vm._n($event.target.value)
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
      ]),
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", { attrs: { for: "inputOutputLimit" } }, [
          _vm._v(_vm._s(_vm.T.settingsOutputLimit)),
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.outputLimit,
              expression: "outputLimit",
              modifiers: { number: true },
            },
          ],
          staticClass: "form-control",
          attrs: { max: "104857600", min: "0", step: "1024", type: "number" },
          domProps: { value: _vm.outputLimit },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.outputLimit = _vm._n($event.target.value)
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
      ]),
    ]),
    _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", { attrs: { for: "inputValidator" } }, [
          _vm._v(_vm._s(_vm.T.settingsValidator)),
        ]),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.validator,
                expression: "validator",
              },
            ],
            staticClass: "form-control",
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.validator = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          [
            _c("option", { attrs: { value: "custom" } }, [_vm._v("Custom")]),
            _c("option", { attrs: { value: "literal" } }, [_vm._v("Literal")]),
            _c("option", { attrs: { value: "token" } }, [_vm._v("Token")]),
            _c("option", { attrs: { value: "token-caseless" } }, [
              _vm._v("Token (Caseless)"),
            ]),
            _c("option", { attrs: { value: "token-numeric" } }, [
              _vm._v("Token (Numeric)"),
            ]),
          ]
        ),
      ]),
      _vm.validator == "token-numeric"
        ? _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", { attrs: { for: "inputTolerance" } }, [
              _vm._v(_vm._s(_vm.T.settingsTolerance)),
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.tolerance,
                  expression: "tolerance",
                  modifiers: { number: true },
                },
              ],
              staticClass: "form-control",
              attrs: { max: "1", min: "0", type: "number" },
              domProps: { value: _vm.tolerance },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.tolerance = _vm._n($event.target.value)
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
          ])
        : _vm._e(),
      _vm.validator == "custom"
        ? _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", { attrs: { for: "inputValidatorLanguage" } }, [
              _vm._v(_vm._s(_vm.T.settingsLanguage)),
            ]),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.validatorLanguage,
                    expression: "validatorLanguage",
                  },
                ],
                staticClass: "form-control",
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.validatorLanguage = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { value: "cpp17-gcc" } }, [
                  _vm._v("C++17"),
                ]),
                _c("option", { attrs: { value: "py3" } }, [
                  _vm._v("Python 3.6"),
                ]),
              ]
            ),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", [_vm._v(_vm._s(_vm.T.detectLanguage))]),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.autoDetectLanguage,
                expression: "autoDetectLanguage",
              },
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.autoDetectLanguage)
                ? _vm._i(_vm.autoDetectLanguage, null) > -1
                : _vm.autoDetectLanguage,
            },
            on: {
              change: [
                function ($event) {
                  var $$a = _vm.autoDetectLanguage,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.autoDetectLanguage = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.autoDetectLanguage = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.autoDetectLanguage = $$c
                  }
                },
                _vm.onAutoDetectChanged,
              ],
            },
          }),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "form-row" }, [
      _c(
        "div",
        { staticClass: "form-group col-md-4" },
        [
          _c("label", { attrs: { for: "inputInteractive" } }, [
            _vm._v(_vm._s(_vm.T.settingsInteractive)),
          ]),
          _c("omegaup-radio-switch", {
            attrs: {
              value: _vm.interactive,
              "selected-value": _vm.interactive,
              name: "interactive",
            },
            on: {
              "update:value": function ($event) {
                _vm.interactive = $event
              },
            },
          }),
        ],
        1
      ),
      _vm.interactive
        ? _c("div", { staticClass: "form-group col-md-4" }, [
            _c("label", { attrs: { for: "inputInteractiveModuleName" } }, [
              _vm._v(_vm._s(_vm.T.settingsModuleName)),
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.interactiveModuleName,
                  expression: "interactiveModuleName",
                },
              ],
              staticClass: "form-control",
              domProps: { value: _vm.interactiveModuleName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.interactiveModuleName = $event.target.value
                },
              },
            }),
          ])
        : _vm._e(),
      _vm.interactive
        ? _c("div", { staticClass: "form-group col-md-4" }, [
            _c("label", { attrs: { for: "inputInteractiveLanguage" } }, [
              _vm._v(_vm._s(_vm.T.settingsLanguage)),
            ]),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.interactiveLanguage,
                    expression: "interactiveLanguage",
                  },
                ],
                staticClass: "form-control",
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.interactiveLanguage = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { value: "cpp17-gcc" } }, [
                  _vm._v("C++17"),
                ]),
                _c("option", { attrs: { value: "py3" } }, [_vm._v("Python")]),
              ]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }